import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 11c-2.4 0-3.7 1.9-5 3.6-1.2 1.6-1.5 4.4.9 4.9 1.6.3 2.9-.5 4.1-.5s2.5.8 4.1.5c2.4-.5 2.1-3.3.9-4.9-1.3-1.7-2.6-3.6-5-3.6\"></path><circle cx=\"5\" cy=\"9.5\" r=\"2\" fill=\"currentColor\"></circle><circle cx=\"9.5\" cy=\"5.5\" r=\"2\" fill=\"currentColor\"></circle><circle cx=\"14.5\" cy=\"5.5\" r=\"2\" fill=\"currentColor\"></circle><circle cx=\"19\" cy=\"9.5\" r=\"2\" fill=\"currentColor\"></circle>", 5)
  ])))
}
export default { render: render }